import { render } from "./ProspectosDetallesContent.vue?vue&type=template&id=024842ba"
import script from "./ProspectosDetallesContent.vue?vue&type=script&lang=js"
export * from "./ProspectosDetallesContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__